// extracted by mini-css-extract-plugin
export default {"features":"features__B5DNN","inner":"inner__TUuUZ","listItems":"listItems__SbKK7","item":"item__e7yq7","containerImage":"containerImage__Lpxjn"};